import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { EventItem } from "core/http/service/internalEvents/types";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: EventItem[];
}

const initialState: InitialState = { status: ReduxStateType.INIT, data: [] };

const getEventsSlice = createSlice({
  name: "getEvents",
  initialState,
  reducers: {
    getEventsStart: (state, action: PayloadAction<{ status: string }>) => {
      state.status = ReduxStateType.LOADING;
    },
    getEventsSuccess: (
      state,
      action: PayloadAction<{
        data: EventItem[];
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...state.data, ...action.payload.data];
    },
    getEventsFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = [];
    },
    resetEvents: () => initialState,
  },
});

export const {
  getEventsStart,
  getEventsSuccess,
  getEventsFailed,
  resetEvents,
} = getEventsSlice.actions;

export default getEventsSlice.reducer;
